import apiCall from '@/api/eos-detective'
import * as accountCategoryData from 'eos-detective-data'

const state = {
  modal: {
    params: {
      account: [],
      direction: 'both',
      accumulated: true
    },
    data: [],
    limited: false,
    error: false,
    edgeModalShow: false,
    nodeModalShow: false
  },
  network: {
    options: {
      interaction: {
        zoomView: true
      },
      edges: {
        arrows: {
          to: { enabled: true, scaleFactor: 1, type: 'arrow' },
          middle: { enabled: false, scaleFactor: 1, type: 'arrow' }
        },
        arrowStrikethrough: false,
        color: {
          color: '#6494ff'
        },
        smooth: {
          enabled: true,
          type: 'continuous',
          forceDirection: 'none',
          roundness: 0.5
        }
      },
      nodes: {
        size: 12,
        shape: 'dot',
        font: {
          size: 14
        }
      },
      layout: {
        improvedLayout: false
      }
    },
    allowSingleClick: true,
    errors: {
      countTotal: null,
      limited: false,
      error: false
    }
  },
  networkGraphData: {
    accounts: [],
    limited: false,
    transfers: []
  },
  networkPhysics: {
    enabled: true,
    maxVelocity: 50,
    minVelocity: 0.7,
    timestep: 0.7,
    solver: 'forceAtlas2Based',
    barnesHut: {
      gravitationalConstant: -2000,
      centralGravity: 0.3,
      springLength: 95,
      springConstant: 0.04,
      damping: 0.09,
      avoidOverlap: 0
    },
    forceAtlas2Based: {
      gravitationalConstant: -100,
      centralGravity: 0.01,
      springLength: 100,
      springConstant: 0.08,
      damping: 0.6,
      avoidOverlap: 0.7
    },
    repulsion: {
      centralGravity: 0.2,
      springLength: 200,
      springConstant: 0.05,
      nodeDistance: 100,
      damping: 0.09
    },
    hierarchicalRepulsion: {
      centralGravity: 0.0,
      springLength: 100,
      springConstant: 0.01,
      nodeDistance: 120,
      damping: 0.09
    }
  },
  eosSpecialAccounts: accountCategoryData.eos,
  bosSpecialAccounts: accountCategoryData.bos,
  networkError: {
    type: undefined,
    error: false,
    code: undefined,
    errorMessage: ''
  }
}

const getters = {
  solverOptions: state => {
    return Object.assign({}, state.network.options, { physics: state.networkPhysics })
  },
  getCategories: (state, getters, rootState) => {
    const mergeAccounts = function (data) {
      let accounts = { blacklist: [] }
      for (let category in data) {
        accounts[category] = []
        for (let subCategory in data[category]) {
          for (let account in data[category][subCategory]) {
            if (subCategory === 'blacklist') accounts[subCategory].push(data[category][subCategory][account])
            else accounts[category].push(data[category][subCategory][account])
          }
        }
      }
      return accounts
    }
    if (rootState.options.selectedChain === 'eos') return mergeAccounts(state.eosSpecialAccounts)
    else return mergeAccounts(state.bosSpecialAccounts)
  },
  getNetworkGraphNodes: (state, getters, rootState, rootGetters) => {
    let tmpNodes = []
    let background = '#ffffff'
    // Add Nodes with Graph Color Options to tmp Array
    state.networkGraphData.accounts.forEach(function (element) {
      tmpNodes.push({
        'color': {
          'background': background,
          'highlight': {
            'background': background
          }
        },
        'id': element._name.split('/')[1],
        'label': element._name.split('/')[1]
      })
    })
    let setNodeParams = function (accounts, color) {
      if (accounts) {
        for (let i in tmpNodes) {
          accounts.forEach(function (account) {
            if (tmpNodes[i].id === account) {
              tmpNodes[i].color.background = color
              tmpNodes[i].color.highlight.background = color
            }
          })
        }
      }
    }
    setNodeParams(getters.getCategories.exchanges, '#d12929')
    setNodeParams(getters.getCategories.system, '#45d1c6')
    setNodeParams(getters.getCategories.dapps, '#ffef05')
    setNodeParams(getters.getCategories.blacklist, '#33424f')
    setNodeParams(rootGetters.getFilterParams.accounts, '#29d129')
    return tmpNodes
  },
  getNetworkGraphEdges: state => {
    let tmpEdges = []
    state.networkGraphData.transfers.forEach(function (element) {
      tmpEdges.push({
        'from': element._from._name.split('/')[1],
        'id': element._from._name.split('/')[1] + '-' + element._to._name.split('/')[1],
        'to': element._to._name.split('/')[1],
        'value': element._quantity,
        'physics': true
      })
    })
    return tmpEdges
  }
}

const actions = {
  async loadNetworkGraphData ({ state, rootState, commit, dispatch, getters, rootGetters }) {
    commit('setTime', null, { root: true })
    commit('setLoading', true, { root: true })
    const excluded = new Set(rootGetters.getExcludedAccounts)
    let accounts = rootGetters.getFilterParams.accounts
    console.log('🚧', excluded, accounts)
    const results = { accounts: [], limited: false, transfers: [] }
    try {
      while (accounts.length) {
        const response = await apiCall({
          apiToken: rootState.auth.profile.userApiToken,
          endpoint: 'transfers',
          params: {
            accounts: accounts.slice(0, 50), // 50 accounts at a time
            params: rootGetters.getFilterParams.params
          }
        })
        accounts = accounts.slice(50)
        if (!response.transfers.length) {
          commit('setNetworkError', { error: true, type: 'Zero Results' })
        } else {
          if (response.limited) {
            commit('setNetworkError', { error: true, type: 'Results Limited' })
          }
        }
        console.log('🥝', response)
        response.accounts.forEach(acc => {
          if (excluded.has(acc.name)) return
          if (results.accounts.find(s => s._name === acc._name)) return
          results.accounts.push(acc)
        })
        response.transfers.forEach(tr => {
          if (excluded.has(tr._from) || excluded.has(tr._to)) return
          const existing = results.transfers.find(s => s._from._name === tr._from._name && s._to._name === tr._to._name)
          if (!existing) results.transfers.push(tr)
          else {
            existing._quantity += tr._quantity
            existing._count += tr._count
          }
        })
      }
      console.log('🏀', results)
      commit('setNetworkGraphData', results)
      setTimeout(function () { commit('setLoading', false, { root: true }) }, 1000)
      setTimeout(() => { commit('setAllowSingleClick', true) }, 200)
    } catch (error) {
      commit('setNetworkError', { error: true, type: 'Network', details: error })
      commit('setLoading', false, { root: true })
      throw error || 'Something went wrong'
    }
  },
  loadAccountData ({ state, commit, rootGetters, rootState }, account) {
    commit('setLoadingModal', true, { root: true })
    let params = rootGetters.getFilterParams.params
    params.accumulated = account.accumulated
    params.direction = account.direction
    if (!params.accumulated) {
      params.accumulated_min = null
      params.accumulated_max = null
    }
    apiCall({
      apiToken: rootState.auth.profile.userApiToken,
      endpoint: 'transfers',
      params: {
        accounts: account.account,
        params: params
      }
    })
      .then((response) => {
        commit('setAccountResults', { account: account, results: response })
        setTimeout(function () { commit('setLoadingModal', false, { root: true }) }, 300)
      })
      .catch((error) => {
        commit('toggleEdgeModal', false)
        commit('toggleNodeModal', false)
        commit('setNetworkError', { error: true, type: 'Network', details: error })
        commit('setLoadingModal', false, { root: true })
      })
  }
}

const mutations = {
  toggleNetworkPhysics (state) {
    state.networkPhysics.enabled = !state.networkPhysics.enabled
  },
  toggleEdgeModal (state, show) {
    state.modal.edgeModalShow = show
  },
  toggleNodeModal (state, show) {
    state.modal.nodeModalShow = show
  },
  setAccountResults (state, results) {
    state.modal.params = results.account
    state.modal.data = results.results
    // state.modal.limited = results.results.limited
    // state.modal.error = results.results.error
  },
  setNetworkGraphData (state, results) {
    state.hasLoadedOnce = true
    state.networkGraphData = results
  },
  setNetworkErrors (state, errors) {
    Reflect.set(state.network.errors, errors.key, errors.value)
  },
  setNetworkError (state, error) {
    if (error) {
      state.networkError.type = error.type
      state.networkError.error = error.error
      if (error.details) {
        state.networkError.code = error.details.code
        state.networkError.errorMessage = error.details.errorMessage
      }
    } else {
      state.networkError.type = undefined
      state.networkError.error = error
      state.networkError.code = undefined
      state.networkError.errorMessage = ''
    }
  },
  updateNetworkOptions (state, data) {
    if (data.category === 'nodes') {
      if (data.option.key === 'labelSize') {
        Reflect.set(state.network.options.nodes.font, 'size', data.option.value)
      } else {
        Reflect.set(state.network.options.nodes, data.option.key, data.option.value)
      }
    }
    if (data.category === 'edgesSmooth') {
      Reflect.set(state.network.options.edges.smooth, data.option.key, data.option.value)
    }
    if (data.category === 'physics') {
      Reflect.set(state.networkPhysics, data.option.key, data.option.value)
    }
    if (data.category === 'solver') {
      state.networkPhysics.solver = data.option.value
    }
    if (data.category === 'solverParam') {
      if (state.networkPhysics.solver === 'barnesHut') {
        Reflect.set(state.networkPhysics.barnesHut, data.option.key, data.option.value)
      }
      if (state.networkPhysics.solver === 'forceAtlas2Based') {
        Reflect.set(state.networkPhysics.forceAtlas2Based, data.option.key, data.option.value)
      }
      if (state.networkPhysics.solver === 'repulsion') {
        Reflect.set(state.networkPhysics.repulsion, data.option.key, data.option.value)
      }
      if (state.networkPhysics.solver === 'hierarchicalRepulsion') {
        Reflect.set(state.networkPhysics.hierarchicalRepulsion, data.option.key, data.option.value)
      }
    }
  },
  setAllowSingleClick (state, event) {
    state.network.allowSingleClick = event
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
